module.exports = __webpack_public_path__ + "static/media/Orange-Paris.f3370a9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/colours/Orange-Paris.jpg
// module id = 118
// module chunks = 0